import { ControlParams, IStaticControl } from "../../Controls/ControlInterfaces";
import { MethodAction } from "./MethodAction";
import { MultiObjectButton } from "./MultiObjectButton";

export class MethodButton extends MultiObjectButton implements IStaticControl {
    public get methodName(): string {
        return (this.xgAction as MethodAction).methodName;
    }
    public get isStatic(): boolean {
        return (this.xgAction as MethodAction).isStatic;
    }

    //#region Constructors
    constructor(params: ControlParams) {
        super({ ...params, action: new MethodAction(params) });
    }
    //#endregion Constructors
}
